import React, { useState, useEffect, useRef } from 'react';
import { Pencil, Trash2, Plus, Eye, User, Search, RefreshCw, X, Send, Check, AlertTriangle, Download, Briefcase, Calendar, Phone, Mail, MapPin, FileText, Clock, User as UserIcon, Building, AlertCircle } from "lucide-react";
import 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';
import DownloadModal from "../../Components/Download/DownloadModal";
import { useLanguage } from '../../StoreContext/LanguageContext';
import { useSignature } from '../../DigitalSignature/UseSignatue';
import { jsPDF } from "jspdf";

import apiService from '../../config';

export default function RailwayObjectionList({ onUpdated, setSubComponent, modalParams, shouldRestoreModal, onNavigateWithModal, setShouldRestoreModal }) {

    // console.log('<><><><><><><><><><><',localStorage.selectedProposal);
    const { language, translations } = useLanguage();
    // Tab state management
    const [activeTab, setActiveTab] = useState('all');

    // Original states from your component
    const [savingId, setSavingId] = useState(null);
    const [activeScreen, setActiveScreen] = useState('list');
    const [selectedObjection, setSelectedObjection] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [isDownloadOpen, setIsDownloadOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: '', type: '' });
    const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'descending' });
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const downloadRef = useRef(null);
    const filterRef = useRef(null);
    const navigate = useNavigate();
    // New state for download modal
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [objections, setObjections] = useState([]);
    const [selectedDocumentLAO, setselectedDocumentLAO] = useState(null);

    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [detailsData, setDetailsData] = useState(null);

    // NEW: Added state for image viewing
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);

    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    // const [showSendToLAOModal, setShowSendToLAOModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [remarks, setRemarks] = useState('Approved');
    const [loadingUsers, setLoadingUsers] = useState(false);
    // const [sendingToLAO, setSendingToLAO] = useState(false);
    const [loadingId, setLoadingId] = useState(null);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [editingStatusId, setEditingStatusId] = useState(null);
    const [selectedDecisionDate, setSelectedDecisionDate] = useState("");
    const [sendingToCollector, setsendingToCollector] = useState(false);

    //Send to Samanvay
    const [showSendToSamanvayModal, setshowSendToSamanvayModal] = useState(false);
    const [selectedDocumentSamanvay, setselectedDocumentSamanvay] = useState(null);
    const [remarksSamanvay, setremarksSamanvay] = useState('Approved');
    const [sendingToSamanvay, setsendingToSamanvay] = useState(false);
    const [usersSamanvay, setusersSamanvay] = useState([]);
    const [loadingusersSamanvay, setLoadingusersSamanvay] = useState(false);
    const [selectedUserSamanvay, setselectedUserSamanvay] = useState('');
    const [selectedUserCollector, setselectedUserCollector] = useState('');
    const [loadingusersCollector, setLoadingusersCollector] = useState(false);
    const [usersCollectorAll, setusersCollectorAll] = useState([]);
    const [remarksCollector, setremarksCollector] = useState('Approved');
    const [selectedDocumentCollector, setselectedDocumentCollector] = useState(null);
    const [sendingToLAO, setsendingToLAO] = useState(false);
    const [sentStatus, setSentStatus] = useState({
        samanvay: false,
        lao: false,
        collector: false,
    });

    // Digital signature
    const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        type: 'warning'
    });
    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };
    // Documents Viewer state
    const [showDocumentViewer, setShowDocumentViewer] = useState(false); // Unified document viewer modal
    const [fileUrlToView, setFileUrlToView] = useState('');
    const [isPDFToView, setIsPDFToView] = useState(false);

    const [decision, setDecision] = useState('');
    const [isProcessingDecision, setIsProcessingDecision] = useState(false);
    const [officerDecision, setOfficerDecision] = useState('');

    const [isSamanvaySent, setIsSamanvaySent] = useState(false);
    const [showSendToCollectorModal, setshowSendToCollectorModal] = useState(false);
    const [showSendToLAOModal, setshowSendToLAOModal] = useState(false);
    const [projectId, setProjectId] = useState(null);
    const [proposalId, setProposalId] = useState(null);
    const [loadingRecords, setLoadingRecords] = useState(false);
    const [selectedUserLAO, setselectedUserLAO] = useState('');
    const [remarksLAO, setremarksLAO] = useState('Approved');
    const [loadingusersLAO, setLoadingusersLAO] = useState(false);
    const [punarvarshanData, setPunarvarshanData] = useState([]);
    const [hasUserEditedSection1, setHasUserEditedSection1] = useState(false);
    const [hasUserEditedTip, setHasUserEditedTip] = useState(false);
    const [usersCollector, setUsersCollector] = useState([]);
    const [usersLAO, setusersLAO] = useState([]);
    const [formData, setFormData] = useState({});
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        message: '',
        type: 'success'
    });
    // Land data
    const [landData, setLandData] = useState([]);

    // Grouped punarvarshan data
    const [punarvarshanGroupedData, setPunarvarshanGroupedData] = useState([]);

    // Collector button disable
    const [collectorEditCompletedbuttonDisabled, setCollectorEditCompletedbuttonDisabled] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [groupedData, setGroupedData] = useState([]);
    const [status, setStatus] = useState("");

    const [userRole, setUserRole] = useState(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            const user = JSON.parse(userData);
            return user.user_role || null;   // role comes from login data
        }
        return null;
    });
    const ROLES = {
        COLLECTOR: 1,
        LAO: 3,
        SAMANVAY: 6,
        PROJECT_INCHARGE: 18,
        DATA_ENTRY: 14
    };
    useEffect(() => {
        allApi();
    }, [projectId && proposalId]);

    const allApi = () => {
        if (projectId && proposalId) {
            fetchLandHoldingData();
            fetchOwnerData();
            fetchusersLAO();
            fetchPunarvarshanData();
            fetchButtonStatus();
        }
    }
    useEffect(() => {
        if (showSendToCollectorModal) {
            fetchUsersAllCollector();
        }
    }, [showSendToCollectorModal]);

    useEffect(() => {
        if (showSendToSamanvayModal) {
            fetchusersSamanvay();
        }
    }, [showSendToSamanvayModal]);

    // fetch Collector users
    const fetchUsersAllCollector = async () => {
        setLoadingusersCollector(true);
        try {
            const response = await apiService.getAllUserCollector();
            console.log('Collector users:', response);
            if (response.status === 200 && response.data) {
                setusersCollectorAll(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersCollectorAll([]);
            }
        } catch (error) {
            console.error('Error fetching Collector users:', error);
            setusersCollectorAll([]);
        } finally {
            setLoadingusersCollector(false);
        }
    };
    // fetch Samanvay users
    const fetchusersSamanvay = async () => {
        setLoadingusersSamanvay(true);
        try {
            const response = await apiService.getAllUserRoleSamanvay();
            console.log('Samanvay users:', response);
            if (response.status === 200 && response.data) {
                setusersSamanvay(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersSamanvay([]);
            }
        } catch (error) {
            console.error('Error fetching Samanvay users:', error);
            setusersSamanvay([]);
        } finally {
            setLoadingusersSamanvay(false);
        }
    };

    const fetchLandHoldingData = async () => {

        // Add validation to ensure both IDs are valid numbers
        if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        const locationParams = { proposalId };
        console.log('Fetching Prathmik Adhisuchna data with:', locationParams);
        console.log('Fetching Prathmik Adhisuchna data with: -', projectId);

        try {
            setLoadingRecords(true);
            console.log("---------------------------1");

            const result = await apiService.getLandHolding(projectId, locationParams);
            console.log("---------------------------2");

            // proposal data - Remove _lao logic
            if (result.status === 200 && Array.isArray(result.proposalData) && result.proposalData.length > 0) {
                const item = result.proposalData[0]; // Taking first record for proposal data

                const newFormData = {};
                Object.keys(formData).forEach(key => {
                    newFormData[key] = item[key] !== undefined && item[key] !== null ? item[key] : '';
                });
                setFormData(newFormData);

                // Check if section_19_content exists in API data
                if (item.section_19_content &&
                    item.section_19_content.trim() !== '' &&
                    item.section_19_content !== 'N/A' &&
                    item.section_19_content !== 'null' &&
                    item.section_19_content !== 'undefined') {
                    setHasUserEditedSection1(true); // Mark as having API content
                }
                if (item.section_19_tip &&
                    item.section_19_tip.trim() !== '' &&
                    item.section_19_tip !== 'N/A' &&
                    item.section_19_tip !== 'null' &&
                    item.section_19_tip !== 'undefined') {
                    setHasUserEditedTip(true); // Mark as having API content
                }
            }

            fetchProposalData();
        } catch (error) {
            console.error('Error fetching Prathmik Adhisuchna data:', error);
            // alert('❌ Error fetching proposal data.');
        } finally {
            setLoadingRecords(false);
        }
    };
    const fetchProposalData = async () => {
        try {
            console.log("Fetching proposal data...");
            // Example: call API
            const response = await apiService.getProposalById(projectId, proposalId);
            console.log("Proposal data:", response);

            // TODO: update states from response
        } catch (err) {
            console.error("Error fetching proposal data:", err);
        }
    };

    const fetchOwnerData = async () => {

        // Add validation to ensure both IDs are valid numbers
        if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        const locationParams = { proposalId };
        console.log('Fetching Prathmik Adhisuchna data with:', locationParams);
        console.log('Fetching Prathmik Adhisuchna data with: -', projectId);

        try {
            setLoadingRecords(true);
            console.log("---------------------------1");

            const result = await apiService.get("getAllOwner", {
                projectId: projectId,
                proposalId: proposalId,
                isActive: 1
            });
            console.log("---------------------------2");

            // Land Acquisition data
            if (result.status === 200 && Array.isArray(result.landAcquisition)) {
                const grouped = {};
                const groupedLand = {};

                result.landAcquisition.forEach(item => {
                    // Only include if owners array exists and has data
                    if (Array.isArray(item.owners) && item.owners.length > 0) {
                        const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
                        if (!grouped[key]) {
                            grouped[key] = [];
                        }

                        // Push each owner as a separate record
                        item.owners.forEach(owner => {
                            grouped[key].push({
                                survey_no: owner.survey_no,
                                aqr_area: owner.owner_aqr_area,
                                total_area: parseFloat(item.total_area || 0),
                                owner_irrigable_area: owner.owner_irrigable_area || 0,
                                owner_non_irrigable_area: owner.owner_non_irrigable_area || 0
                            });
                        });
                    }

                    // Irrigable
                    const landKey = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
                    if (!groupedLand[landKey]) {
                        groupedLand[landKey] = [];
                    }

                    groupedLand[landKey].push({
                        survey_no: item.survey_no,
                        irrigable_area: item.irrigable_area,
                        non_irrigable_area: item.non_irrigable_area,
                        total_area: parseFloat(item.total_area || 0),
                    })

                });

                // Convert to array for rendering
                const groupedArray = Object.entries(grouped).map(([key, records]) => {
                    const [dist, taluka, village] = key.split('-');

                    // Owner
                    const ownerTotalIrrigable = records.reduce(
                        (sum, r) => sum + parseFloat(r.owner_irrigable_area || 0),
                        0
                    );

                    const ownerTotalNonIrrigable = records.reduce(
                        (sum, r) => sum + parseFloat(r.owner_non_irrigable_area || 0),
                        0
                    );

                    const total = records.reduce((sum, r) => sum + parseFloat(r.aqr_area || 0), 0);
                    return { dist, taluka, village, records, total, ownerTotalIrrigable, ownerTotalNonIrrigable };
                });

                const holderData = Object.entries(groupedLand).map(([key, records]) => {
                    const [dist, taluka, village] = key.split('-');
                    const irrigableTotal = records.reduce((sum, r) => sum + parseFloat(r.irrigable_area || 0), 0);
                    const nonIrrigableTotal = records.reduce((sum, r) => sum + parseFloat(r.non_irrigable_area || 0), 0);
                    const finalTotal = records.reduce((sum, r) => sum + parseFloat(r.total_area || 0), 0);
                    return { dist, taluka, village, records, irrigableTotal, nonIrrigableTotal, finalTotal };
                });

                setGroupedData(groupedArray);
                setLandData(holderData);
            }

            fetchProposalData();
        } catch (error) {
            console.error('Error fetching Prathmik Adhisuchna data:', error);
            // alert('❌ Error fetching proposal data.');
        } finally {
            setLoadingRecords(false);
        }
    };

    // fetch LAO users
    const fetchusersLAO = async () => {
        const role = 3;
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const selectedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
        const proposalId = selectedProposal?.acquisition_proposal_id;
        setLoadingusersLAO(true);
        try {
            const response = await apiService.getAssignLAO(role, projectId, proposalId);
            console.log('LAO users:', response);
            if (response.status === 200 && response.data) {
                setusersLAO(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersLAO([]);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setusersLAO([]);
        } finally {
            setLoadingusersLAO(false);
        }
    };

    const fetchPunarvarshanData = async () => {
        if (!projectId || !proposalId) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        try {
            setLoadingRecords(true);

            const result = await apiService.get("getPunarvarshan", {
                projectId: projectId,
                proposalId: proposalId
            });

            if (result.status === 200 && Array.isArray(result.data) && result.data.length > 0) {
                setPunarvarshanData(
                    result.data.map(item => ({
                        id: item.punarvarshan_id,      // use API id
                        survey_no: item.survey_no,
                        aquire_area: item.aquire_area,
                        dist_name: item.dist_name,
                        taluka_name: item.taluka_name,
                        village_name: item.village_name
                    }))
                );
                // Group data by dist-taluk-village
                const grouped = {};

                result.data.forEach(item => {
                    const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
                    if (!grouped[key]) {
                        grouped[key] = [];
                    }

                    grouped[key].push({
                        id: item.punarvarshan_id,
                        survey_no: item.survey_no,
                        aquire_area: item.aquire_area
                    });
                });

                // Convert into array format for rendering
                const groupedArray = Object.entries(grouped).map(([key, records]) => {
                    const [dist, taluka, village] = key.split('-');
                    const total = records.reduce((sum, r) => sum + parseFloat(r.aquire_area || 0), 0);
                    return { dist, taluka, village, records, total };
                });

                setPunarvarshanGroupedData(groupedArray);
            }

        } catch (error) {
            console.error('Error fetching Punarvarshan data:', error);
        } finally {
            setLoadingRecords(false);
        }
    };

    // Button Disable
    const fetchButtonStatus = async () => {
        try {
            if (!projectId || !proposalId) return;

            // setLoading(true);
            let response;

            // Edit button disable
            response = await apiService.getfetchLAOPublishSection19Button(projectId, proposalId);
            setCollectorEditCompletedbuttonDisabled(!response.buttonDisable);

            switch (userRole) {
                case ROLES.LAO:
                    response = await apiService.getfetchSamanvayButtonSection19(projectId, proposalId);
                    break;
                case ROLES.SAMANVAY:
                    response = await apiService.getfetchCollectorButtonSection19(projectId, proposalId);
                    break;
                case ROLES.COLLECTOR:
                    response = await apiService.getfetchLAOPublishSection19Button(projectId, proposalId);
                    break;
                default:
                    return;
            }
            setButtonDisabled(!response.buttonDisable);
        } catch (error) {
            console.error("Error fetching DSLR button state:", error);
        } finally {
            // setLoading(false); // Only set loading to false for main data fetch
        }
    };
    useEffect(() => {
        if (showSendToCollectorModal) {
            fetchUsersCollector();
        }
    }, [showSendToCollectorModal]);

    useEffect(() => {
        if (showSendToLAOModal) {
            fetchusersLAO();
        }
    }, [showSendToLAOModal]);
    const closeDocumentViewer = () => {
        setShowDocumentViewer(false);
        // Revoke Object URL if it was created from a File object
        if (fileUrlToView.startsWith('blob:')) {
            URL.revokeObjectURL(fileUrlToView);
        }
        setFileUrlToView('');
        setIsPDFToView(false);
    };
    // fetch Collector users
    const fetchUsersCollector = async () => {
        const role = 1; // Collector role
        setLoadingusersCollector(true);
        try {
            const response = await apiService.getAssignCollector(role, projectId, proposalId);
            console.log('Collector users:', response);
            if (response.status === 200 && response.data) {
                setUsersCollector(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsersCollector([]);
            }
        } catch (error) {
            console.error('Error fetching Collector users:', error);
            setUsersCollector([]);
        } finally {
            setLoadingusersCollector(false);
        }
    };


    // Handle Send to Collector
    const handleSendToCollector = async () => {
        if (!selectedUserCollector || !selectedDocumentCollector) {
            alert('Please select a user and upload a document to send to Collector Officer.');
            return;
        }
        const getProjectAndProposalIds = () => {
            // Try multiple sources for project ID
            let projectId = currentProjectId;
            if (!projectId) {
                const selectedProject = localStorage.getItem('selectedProject');
                if (selectedProject) {
                    try {
                        const project = JSON.parse(selectedProject);
                        projectId = project.id || project.project_id;
                    } catch (e) {
                        console.error('Error parsing selected project:', e);
                    }
                }
            }

            // Try multiple sources for proposal ID
            let proposalId = currentProposalId;
            if (!proposalId) {
                proposalId = localStorage.getItem('currentProposalId');
            }
            if (!proposalId) {
                const selectedProposal = localStorage.getItem('selectedProposal');
                if (selectedProposal) {
                    try {
                        const proposal = JSON.parse(selectedProposal);
                        proposalId = proposal.id || proposal.proposal_id;
                    } catch (e) {
                        console.error('Error parsing selected proposal:', e);
                    }
                }
            }

            return { projectId, proposalId };
        };

        const { projectId, proposalId } = getProjectAndProposalIds();

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setsendingToCollector(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksCollector);
            formData.append('usr_id', selectedUserCollector);
            formData.append('document', selectedDocumentCollector);

            const response = await apiService.postTrackingCollectorObjection(formData);
            console.log('Send to Collector response:', response);

            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToCollectorOfficer
                    || "Successfully sent to Collector Officer!"
                );
                // alert('Successfully sent to Collector Officer!');
                allApi();
                setshowSendToCollectorModal(false);
                setselectedUserCollector('');
                setremarksCollector('Approved');
                setselectedDocumentCollector(null);
                fetchButtonStatus();

            } else {
                alert('Failed to send to Collector Officer. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to Collector:', error);
            alert('Failed to send to Collector Officer. Please try again.');
        } finally {
            setsendingToCollector(false);
        }
    };

    // Handle Send to LAO
    const handleSendToLAO = async () => {
        if (!selectedUserLAO || !selectedDocumentLAO) {
            alert('Please select a user and upload a document to send to LAO Officer.');
            return;
        }
        const getProjectAndProposalIds = () => {
            // Try multiple sources for project ID
            let projectId = currentProjectId;
            if (!projectId) {
                const selectedProject = localStorage.getItem('selectedProject');
                if (selectedProject) {
                    try {
                        const project = JSON.parse(selectedProject);
                        projectId = project.id || project.project_id;
                    } catch (e) {
                        console.error('Error parsing selected project:', e);
                    }
                }
            }

            // Try multiple sources for proposal ID
            let proposalId = currentProposalId;
            if (!proposalId) {
                proposalId = localStorage.getItem('currentProposalId');
            }
            if (!proposalId) {
                const selectedProposal = localStorage.getItem('selectedProposal');
                if (selectedProposal) {
                    try {
                        const proposal = JSON.parse(selectedProposal);
                        proposalId = proposal.id || proposal.proposal_id;
                    } catch (e) {
                        console.error('Error parsing selected proposal:', e);
                    }
                }
            }

            return { projectId, proposalId };
        };

        const { projectId, proposalId } = getProjectAndProposalIds();

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setsendingToLAO(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksLAO);
            formData.append('usr_id', selectedUserLAO);
            formData.append('document', selectedDocumentLAO);

            const response = await apiService.postTrackingLAOObjection(formData);
            console.log('Send to LAO response:', response);

            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToLAOOfficer
                    || "Successfully sent to LAO Officer!"
                );
                // alert('Successfully sent to LAO Officer!');
                await allApi();
                setshowSendToLAOModal(false);
                setselectedUserLAO('');
                setremarksLAO('Approved');
                setselectedDocumentLAO(null);
                fetchButtonStatus();

            } else {
                alert('Failed to send to LAO Officer. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to LAO:', error);
            alert('Failed to send to LAO Officer. Please try again.');
        } finally {
            setsendingToLAO(false);
        }
    };

    // Handle Send to Samanvay
    const handleSendToSamanvay = async () => {
        if (!selectedUserSamanvay || !selectedDocumentSamanvay) {
            setNotification({
                show: true,
                type: 'error',
                message: 'Please select a user and upload a document to send to Samanvay Officer.'
            });
            return;
        }

        const getProjectAndProposalIds = () => {
            let projectId = currentProjectId;
            if (!projectId) {
                const selectedProject = localStorage.getItem('selectedProject');
                if (selectedProject) {
                    try {
                        const project = JSON.parse(selectedProject);
                        projectId = project.id || project.project_id;
                    } catch (e) {
                        console.error('Error parsing selected project:', e);
                    }
                }
            }

            let proposalId = currentProposalId;
            if (!proposalId) {
                proposalId = localStorage.getItem('currentProposalId');
            }
            if (!proposalId) {
                const selectedProposal = localStorage.getItem('selectedProposal');
                if (selectedProposal) {
                    try {
                        const proposal = JSON.parse(selectedProposal);
                        proposalId = proposal.id || proposal.proposal_id;
                    } catch (e) {
                        console.error('Error parsing selected proposal:', e);
                    }
                }
            }

            return { projectId, proposalId };
        };

        const { projectId, proposalId } = getProjectAndProposalIds();

        if (!projectId || !proposalId) {
            setNotification({
                show: true,
                type: 'error',
                message: 'Project ID and Proposal ID are required. Please ensure you have selected a project.'
            });
            return;
        }

        setsendingToSamanvay(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksSamanvay || 'Approved');
            formData.append('usr_id', selectedUserSamanvay);

            const documentToSend = uploadStatus === 'success' && selectedSignDocument
                ? selectedSignDocument
                : selectedDocumentSamanvay;

            if (documentToSend) {
                formData.append('document', documentToSend);
            }

            console.log('Sending to Samanvay with data:', {
                project_id: projectId,
                proposal_id: proposalId,
                remarks: remarksSamanvay,
                usr_id: selectedUserSamanvay,
                document: documentToSend?.name,
            });

            const response = await apiService.postTrackingSamanvayObjection(formData);

            if (response && (response.status === 200 || response.status === 201)) {
                setSentStatus(prev => ({ ...prev, samanvay: true }));
                setNotification({
                    show: true,
                    type: 'success',
                    message: 'Successfully sent to Samanvay Officer!'
                });
                setIsSamanvaySent(true);
                setshowSendToSamanvayModal(false);
                setselectedUserSamanvay('');
                setremarksSamanvay('Approved');
                setselectedDocumentSamanvay(null);
                resetSignatureState();
                setButtonDisabled(true);
            } else {
                throw new Error(`Unexpected response status: ${response?.status}`);
            }
        } catch (error) {
            console.error('Error sending to Samanvay:', error);
            setNotification({
                show: true,
                type: 'error',
                message: error.response?.data?.message || 'Failed to send to Samanvay Officer. Please try again.'
            });
        } finally {
            setsendingToSamanvay(false);
        }
    };

    const userData = JSON.parse(localStorage.getItem('userData'));
    // const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

    useEffect(() => {
        const fetchSamanvayButtonStatus = async () => {
            try {
                if (currentProjectId && currentProposalId) {
                    console.log('Fetching Samanvay status for:', { currentProjectId, currentProposalId });
                    const res = await apiService.getSendToSamanvayObjectionButton(currentProjectId, currentProposalId);
                    console.log('Samanvay button response:', res);

                    setIsSamanvaySent(!res.buttonDisable); // mark as already sent (red button)
                    console.log('isSamanvaySent set to:', !res.buttonDisable);
                }
            } catch (err) {
                console.error("Error fetching Samanvay button status:", err);
                // Set default state on error
                setIsSamanvaySent(false);
            }
        };
        fetchSamanvayButtonStatus();
    }, [currentProjectId, currentProposalId]);


    // Enhanced field mapping for better display
    const getFieldLabel = (key) => {
        const fieldLabels = {
            'objector_name': <span>{translations[language].objectorName}</span>,
            'objector_address': <span>{translations[language].objectorAddress}</span>,
            'objector_contact': 'Contact Number',
            'objector_email': 'Email Address',
            'objection_date': <span>{translations[language].objectionDate}</span>,
            'objection_summary': 'Objection Summary',
            'objection_details': <span>{translations[language].objectionDetails}</span>,
            'objection_status': <span>{translations[language].CurrentStatus}</span>,
            'project_id': <span>{translations[language].projectId}</span>,
            'project_name': 'Project Name',
            'submission_date': 'Submission Date',
            'last_updated': 'Last Updated',
            'priority_level': 'Priority Level',
            'category': 'Category',
            'affected_area': 'Affected Area',
            'compensation_requested': 'Compensation Requested',
            'resolution_required': 'Resolution Required',
            'documentation_provided': 'Documentation Provided',
            'supporting_documents': 'Supporting Documents',
            'document_references': 'Document References',
            'identity_proof_no': 'Identity Proof Number',
            'identity_proof_type': 'Identity Proof Type',
            'objection_id': 'Objection ID',
            'objector_type': 'Objector Type',
            'affected_survey_no': <span>{translations[language].affectedSurveyNo}</span>,
            'village_name': 'Affected Village',
            'taluka_name': 'Affected Taluka',
            'dist_name': 'Affected District',
            'objection_category': 'Objection Category',
            // 'review_comments': 'Review Comments',
            'resolution_details': 'Resolution Details',
            'resolution_date': 'Resolution Date',
            'hearing_date': 'Hearing Date',
            'hearing_venue': 'Hearing Venue',
            'hearing_officer': 'Hearing Officer',
            'hearing_designation': 'Hearing Designation',
            'case_no': <span>{translations[language].caseNumber}</span>,
            // Handle both camelCase and snake_case versions
            'identityproof': 'Identity Proof',
            'identity_proof': 'Identity Proof',

        };

        // Try direct lookup first
        if (fieldLabels[key]) return fieldLabels[key];

        // Try lowercase lookup
        const lowerKey = key.toLowerCase();
        if (fieldLabels[lowerKey]) return fieldLabels[lowerKey];

        // Convert camelCase to snake_case and try lookup
        const snakeCase = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        if (fieldLabels[snakeCase]) return fieldLabels[snakeCase];

        // Fallback: create readable version from key
        return key.replace(/_/g, ' ')
            .replace(/([A-Z])/g, ' $1')
            .trim()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Get appropriate icon for each field
    const getFieldIcon = (key) => {
        const lowerKey = key.toLowerCase();
        if (lowerKey.includes('name')) return <UserIcon className="h-4 w-4" />;
        if (lowerKey.includes('address') || lowerKey.includes('location')) return <MapPin className="h-4 w-4" />;
        if (lowerKey.includes('contact') || lowerKey.includes('phone')) return <Phone className="h-4 w-4" />;
        if (lowerKey.includes('email')) return <Mail className="h-4 w-4" />;
        if (lowerKey.includes('date') || lowerKey.includes('time')) return <Calendar className="h-4 w-4" />;
        if (lowerKey.includes('status')) return <AlertCircle className="h-4 w-4" />;
        if (lowerKey.includes('project')) return <Building className="h-4 w-4" />;
        if (lowerKey.includes('summary') || lowerKey.includes('details') || lowerKey.includes('description')) return <FileText className="h-4 w-4" />;
        return <FileText className="h-4 w-4" />;
    };

    // Format field values for better display
    const formatFieldValue = (key, value) => {
        if (typeof value === 'string' && (key.includes('date') || key.includes('time')) && !isNaN(Date.parse(value))) {
            return new Date(value).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: key.includes('time') ? '2-digit' : undefined,
                minute: key.includes('time') ? '2-digit' : undefined
            }).replace(',', '');
        }
        if (typeof value === 'object' && value !== null) {
            return JSON.stringify(value, null, 2);
        }
        return String(value || 'No Data available');
    };

    // Get status color and styling
    const getStatusStyling = (status) => {
        const statusLower = status?.toLowerCase() || '';
        if (statusLower.includes('pending')) {
            return 'bg-yellow-100 text-yellow-800 border-yellow-200';
        } else if (statusLower.includes('approved') || statusLower.includes('completed')) {
            return 'bg-green-100 text-green-800 border-green-200';
        } else if (statusLower.includes('rejected') || statusLower.includes('denied')) {
            return 'bg-red-100 text-red-800 border-red-200';
        } else if (statusLower.includes('in progress') || statusLower.includes('scheduled')) {
            return 'bg-blue-100 text-blue-800 border-blue-200';
        }
        return 'bg-gray-100 text-gray-800 border-gray-200';
    };

    // NEW: Check if field contains image/document URL
    const isImageField = (key, value) => {
        const lowerKey = key.toLowerCase();
        const stringValue = String(value || '').toLowerCase();

        return (
            (lowerKey.includes('proof') ||
                lowerKey.includes('document') ||
                lowerKey.includes('attachment')) &&
            (stringValue.includes('http') ||
                stringValue.includes('.jpg') ||
                stringValue.includes('.jpeg') ||
                stringValue.includes('.png') ||
                stringValue.includes('.pdf'))
        );
    };

    // NEW: Handle image viewing
    const handleViewImage = (imageUrl, fieldName) => {
        setSelectedImage({
            url: imageUrl,
            title: fieldName
        });
        setShowImageModal(true);
    };

    // NEW: Image modal component
    const renderImageModal = () => {
        if (!showImageModal || !selectedImage) return null;

        return (
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[60] p-4">
                <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                    <div className="bg-gradient-to-r from-blue-600 to-blue-800 px-6 py-4">
                        <div className="flex justify-between items-center">
                            <div className="flex items-center space-x-3">
                                <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                                    <FileText className="h-6 w-6 text-white" />
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-white">{selectedImage.title}</h3>
                                    <p className="text-blue-100 text-sm">Document Preview</p>
                                </div>
                            </div>
                            <button
                                onClick={() => setShowImageModal(false)}
                                className="text-white hover:text-gray-200 transition-colors p-2 hover:bg-white hover:bg-opacity-10 rounded-lg"
                            >
                                <X className="h-6 w-6" />
                            </button>
                        </div>
                    </div>

                    <div className="p-6 max-h-[calc(90vh-120px)] overflow-auto">
                        <div className="flex justify-center">
                            {selectedImage.url.toLowerCase().includes('.pdf') ? (
                                <iframe
                                    src={selectedImage.url}
                                    className="w-full h-96 border rounded-lg"
                                    title="PDF Viewer"
                                />
                            ) : (
                                <img
                                    src={selectedImage.url}
                                    alt={selectedImage.title}
                                    className="max-w-full max-h-full object-contain rounded-lg shadow-lg"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'block';
                                    }}
                                />
                            )}
                            <div className="hidden text-center text-gray-500 p-8 border-2 border-dashed border-gray-300 rounded-lg">
                                <FileText className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                                <p>Unable to load image</p>
                                <a href={selectedImage.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                                    Open in new tab
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                        <div className="flex justify-between items-center">
                            <a href={selectedImage.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline flex items-center">
                                <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                                Open in new tab
                            </a>
                            <button
                                onClick={() => setShowImageModal(false)}
                                className="px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderDetailsModal = () => {
        if (!showDetailsModal || !detailsData) return null;

        const excludedFields = [
            'supporting_documents',
            'objector_email',
            'id',
            'type',
            'objection_other',
            'document_references',
            'identity_proof_no',
            'identity_proof_type',
            'identityProof',
            'village_name',
            'taluka_name',
            'dist_name',
            'objector_contact',
            'objection_category',
            'objector_type',
            'objection_summary',
            'objection_no',
            'objection_id',
            'supportive_document',
            'hearing_outcome',
            'is_active',
            'cre_usr_dt',
            'last_upd_id',
            'last_upd_dt',
            'otp',
            'cre_usr_id',
            'hearing_required',
            'review_comments',
            'resolution_details',
            'resolution_date',
            'hearing_date',
            'hearing_venue',
            'hearing_officer',
            'hearing_designation',
        ];
        const handleSave = async (objectionData) => {
            if (!selectedDecisionDate || !decision || !officerDecision) {
                setNotification({
                    show: true,
                    type: 'error',
                    message: 'Please select both decision and date'
                });
                return;
            }

            setIsProcessingDecision(true);
            try {
                const numericId = objectionData.id?.replace(/^[GP]/, '') || objectionData.objection_id || objectionData.pobjection_id;

                // Determine if it's general or private objection
                const isPrivateObjection = objectionData.type === 'Private' || objectionData.pobjection_id;

                const updateData = {
                    OBJECTION_STATUS: decision,
                    hearing_date: selectedDecisionDate,
                    hearing_outcome: officerDecision
                };

                let response;
                if (isPrivateObjection) {
                    // response = await apiService.patchUpdatePrivateObjection(numericId, updateData);
                } else {
                    response = await apiService.patchUpdateGeneralObjection(numericId, updateData);
                }

                // Update the objections list
                const updatedObjections = objections.map((obj) => {
                    const objNumeric = obj.id.replace(/^[GP]/, '');
                    return objNumeric === numericId
                        ? {
                            ...obj, status: decision, hearing_date: selectedDecisionDate, hearing_outcome: officerDecision
                        }
                        : obj;
                });
                setObjections(updatedObjections);

                // Update the details data
                setDetailsData({
                    ...objectionData,
                    OBJECTION_STATUS: decision,
                    objection_status: decision,
                    hearing_date: selectedDecisionDate,
                    hearing_outcome: officerDecision
                });

                setNotification({
                    show: true,
                    type: 'success',
                    message: 'Status updated successfully'
                });

                // Reset form
                setDecision('');
                setSelectedDecisionDate('');
                setOfficerDecision('');

            } catch (error) {
                console.error('Error updating objection status:', error);
                setNotification({
                    show: true,
                    type: 'error',
                    message: 'Failed to update status'
                });
            } finally {
                setIsProcessingDecision(false);
            }
        };
        // Fields that should appear at the bottom of detailed information
        const bottomFields = [
            'supporting_documents',
            'document_references',
        ];

        // Separate important fields for prominent display
        const importantFields = ['objector_name', 'objection_status', 'objection_date', 'objector_address', 'objection_details'];

        // Filter out excluded fields and separate prominent vs regular vs bottom fields
        const allFilteredData = Object.entries(detailsData).filter(([key, value]) =>
            !excludedFields.includes(key.toLowerCase())
        );

        const prominentFields = allFilteredData.filter(([key]) => importantFields.includes(key.toLowerCase()));

        // Check for bottom fields with both exact matches and keyword matches
        const bottomSectionFields = allFilteredData.filter(([key]) => {
            const lowerKey = key.toLowerCase();
            const originalKey = key; // Keep original for exact matches

            return bottomFields.includes(lowerKey) ||
                lowerKey.includes('supporting') ||
                lowerKey.includes('document_ref');
        });

        const regularFields = allFilteredData.filter(([key]) => {
            const lowerKey = key.toLowerCase();
            const originalKey = key; // Keep original for exact matches

            return !importantFields.includes(lowerKey) &&
                !bottomFields.includes(lowerKey) &&
                originalKey !== 'identity Proof' && // Exclude exact match for field in screenshot
                originalKey !== 'identityProof' &&
                !(lowerKey.includes('identity') && (lowerKey.includes('proof') || lowerKey.includes('document'))) &&
                !lowerKey.includes('supporting') &&
                !lowerKey.includes('document_ref') &&
                lowerKey !== 'affected_village_old' &&
                lowerKey !== 'affected_taluka_old' &&
                lowerKey !== 'affected_district_old';
        });

        // Sort regularFields to put case_no first
        const sortedRegularFields = regularFields.sort(([keyA], [keyB]) => {
            if (keyA.toLowerCase() === 'case_no') return -1;
            if (keyB.toLowerCase() === 'case_no') return 1;
            return 0;
        });

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                <div className="bg-white rounded-2xl shadow-2xl max-w-6xl w-full max-h-[95vh] overflow-hidden">
                    {/* Enhanced Modal Header */}
                    <div className="bg-gradient-to-r from-blue-600 to-blue-800 px-8 py-6">
                        <div className="flex justify-between items-center">
                            <div className="flex items-center space-x-4">
                                <div className="bg-white bg-opacity-20 p-3 rounded-lg">
                                    <FileText className="h-8 w-8 text-white" />
                                </div>
                                <div>
                                    <h3 className="text-2xl font-bold text-white">{translations[language].objectionDetails}</h3>
                                    <p className="text-blue-100 text-sm mt-1">Complete objection information and details</p>
                                </div>
                            </div>
                            <button
                                onClick={() => setShowDetailsModal(false)}
                                className="text-white hover:text-gray-200 transition-colors p-2 hover:bg-white hover:bg-opacity-10 rounded-lg"
                            >
                                <X className="h-6 w-6" />
                            </button>
                        </div>
                    </div>

                    {/* Modal Content with improved layout */}
                    <div className="overflow-y-auto max-h-[calc(95vh-200px)]">
                        {/* Prominent Information Cards */}
                        {prominentFields.length > 0 && (
                            <div className="p-8 bg-gray-50 border-b border-gray-200">
                                <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                    <AlertCircle className="h-5 w-5 mr-2 text-blue-600" />
                                    Key Information
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                    {prominentFields.map(([key, value]) => (
                                        <div key={key} className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
                                            <div className="flex items-center space-x-3 mb-2">
                                                <div className="text-blue-600">
                                                    {getFieldIcon(key)}
                                                </div>
                                                <span className="text-sm font-medium text-gray-600">
                                                    {getFieldLabel(key)}
                                                </span>
                                            </div>
                                            <div className="mt-2">
                                                {key.toLowerCase().includes('status') ? (
                                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getStatusStyling(value)}`}>
                                                        {formatFieldValue(key, value)}
                                                    </span>
                                                ) :
                                                    <p className="text-gray-900 font-medium">
                                                        {formatFieldValue(key, value)}
                                                    </p>
                                                }
                                            </div>

                                        </div>
                                    ))}
                                </div>
                                {/* Decision Selection Section - Only show if status is Pending */}
                                {((detailsData?.objection_status?.toLowerCase() === 'pending' ||
                                    detailsData?.OBJECTION_STATUS?.toLowerCase() === 'pending') && userRole === 3) ? (
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                                        {/* निर्णय निवडा - First Field */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                निर्णय निवडा *
                                            </label>
                                            <select
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm 
        focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                value={decision}
                                                onChange={(e) => setDecision(e.target.value)}
                                                disabled={isProcessingDecision}
                                            >
                                                <option value="">-- निर्णय निवडा * --</option>
                                                <option value="Completed">पूर्ण झाले म्हणून चिन्हांकित करा</option>
                                                <option value="Rejected">अपूर्ण म्हणून चिन्हांकित करा</option>
                                            </select>
                                        </div>

                                        {/* सुनावणी - Second Field (shows after decision is selected) */}
                                        {decision && (
                                            <div className="animate-fadeIn">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    सुनावणी *
                                                </label>
                                                <input
                                                    type="date"
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm 
          focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    value={selectedDecisionDate}
                                                    onChange={(e) => setSelectedDecisionDate(e.target.value)}
                                                    disabled={isProcessingDecision}
                                                    min={new Date().toISOString().split("T")[0]} // Prevent past dates
                                                />
                                            </div>
                                        )}

                                        {/* भूसंपादन अधिकाऱ्याचा निर्णय - Third Field (shows after date is selected) */}
                                        {decision && selectedDecisionDate && (
                                            <div className="animate-fadeIn">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    भूसंपादन अधिकाऱ्याचा निर्णय *
                                                </label>
                                                <textarea
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm 
          focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                                                    rows="3"
                                                    value={officerDecision}
                                                    onChange={(e) => setOfficerDecision(e.target.value)}
                                                    disabled={isProcessingDecision}
                                                    placeholder="Enter officer's decision..."
                                                />
                                            </div>
                                        )}

                                        {/* Save Button - Fourth Field (shows after all fields are filled) */}
                                        {decision && selectedDecisionDate && officerDecision && (
                                            <div className="animate-fadeIn">
                                                <button
                                                    onClick={() => handleSave(detailsData)}
                                                    disabled={isProcessingDecision || !decision || !selectedDecisionDate || !officerDecision}
                                                    className="w-full px-4 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white 
          font-medium rounded-lg hover:from-green-700 hover:to-green-800 
          focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 
          transition-all duration-200 disabled:from-gray-400 disabled:to-gray-500 
          disabled:cursor-not-allowed flex items-center justify-center shadow-lg"
                                                >
                                                    {isProcessingDecision ? (
                                                        <>
                                                            <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                                                            Processing...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Check className="h-4 w-4 mr-2" />
                                                            Save Decision
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                ) : (
                                    // FIXED: Show current status info for non-pending objections (this section appears only once now)
                                    <div className="mt-6 pt-6 border-t border-gray-200">
                                        <div className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-3">
                                                    <div className="p-2 bg-green-100 rounded-lg">
                                                        <Check className="h-5 w-5 text-green-600" />
                                                    </div>
                                                    <div>
                                                        <h6 className="font-medium text-gray-900">
                                                            सध्याची स्थिती: {detailsData?.objection_status || detailsData?.OBJECTION_STATUS}
                                                        </h6>
                                                        {detailsData?.hearing_date && (
                                                            <p className="text-sm text-gray-500">
                                                                तारीख : {new Date(detailsData.hearing_date).toLocaleDateString('en-GB').replace(/\//g, '-')}
                                                            </p>
                                                        )}
                                                        {detailsData?.hearing_outcome && (
                                                            <p className="text-sm text-gray-600 mt-1">
                                                                भूसंपादन अधिकाऱ्याचा निर्णय: {detailsData.hearing_outcome}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Supporting Documents and Identity Information - Bottom Section */}
                                {bottomSectionFields.length > 0 && (
                                    <div className="mt-8 pt-6 border-t border-gray-200">
                                        <h5 className="text-md font-semibold text-gray-800 mb-4 flex items-center">
                                            <FileText className="h-4 w-4 mr-2 text-blue-600" />
                                            <span>{translations[language].SupportingDocumentsReferences}</span>
                                        </h5>
                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                            {bottomSectionFields.map(([key, value]) => (
                                                <div key={key} className="bg-white rounded-xl p-5 border border-gray-200 hover:border-gray-300 transition-colors shadow-sm hover:shadow-md">
                                                    <div className="flex items-start space-x-3">
                                                        <div className="flex-shrink-0 mt-1">
                                                            <div className="p-2 bg-blue-50 rounded-lg text-blue-600">
                                                                {getFieldIcon(key)}
                                                            </div>
                                                        </div>
                                                        <div className="flex-1 min-w-0">
                                                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                                {getFieldLabel(key)}
                                                            </label>
                                                            <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                                                                {isImageField(key, value) ? (
                                                                    <div className="flex items-center justify-between">
                                                                        <div className="flex items-center space-x-2">
                                                                            <FileText className="h-4 w-4 text-gray-500" />
                                                                            <span className="text-sm text-gray-600">Document attached</span>
                                                                        </div>
                                                                        <button
                                                                            onClick={() => handleViewImage(value, getFieldLabel(key))}
                                                                            className="px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-md transition-colors duration-200 flex items-center space-x-1"
                                                                        >
                                                                            <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                                            </svg>
                                                                            <span>View</span>
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <p className="text-gray-800 font-medium">
                                                                        {formatFieldValue(key, value)}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}


                    </div>

                    {/* Enhanced Modal Footer */}
                    <div className="bg-gray-50 px-8 py-6 border-t border-gray-200">
                        <div className="flex justify-between items-center">
                            <div className="text-sm text-gray-500">
                                <Clock className="h-4 w-4 inline mr-1" />
                                Last updated: {new Date().toLocaleDateString()}
                            </div>
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={() => setShowDetailsModal(false)}
                                    className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                >
                                    {translations[language].Close}
                                </button>
                                {/* {detailsData?.status?.toLowerCase() !== 'completed' && (
                                    <button
                                        onClick={() => handleHearing(detailsData)}
                                        className="px-6 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-lg shadow-blue-200 flex items-center"
                                    >
                                        <Calendar className="h-4 w-4 mr-2" />
                                        {translations[language].ScheduleHearing}
                                    </button>
                                )} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Get project ID from localStorage or context
    useEffect(() => {
        const getProjectInfo = () => {
            // Try to get from current project data first
            const currentProjectData = localStorage.getItem('currentProjectData');
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return {
                        id: projectData.project_id || projectData.id,
                        name: projectData.project_name || projectData.name
                    };
                } catch (e) {
                    console.error('Error parsing current project data:', e);
                }
            }
            // Try to get from selected project in localStorage
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selected project:', e);
                }
            }

            // Fallback to userData
            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    return {
                        id: user.data?.project_id || user.project_id,
                        name: user.data?.project_name || user.project_name || 'Unknown Project'
                    };
                } catch (e) {
                    console.error('Error parsing user data:', e);
                }
            }

            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setCurrentProjectId(projectInfo.id);
        setCurrentProjectName(projectInfo.name);
        const currentProposalId = localStorage.getItem('currentProposalId');
        if (currentProposalId) {
            setCurrentProposalId(currentProposalId);
        }
        console.log('Current Project Info:', projectInfo);
    }, []);

    useEffect(() => {
        if (!currentProjectId) return;

        const fetchAllObjections = async () => {
            try {
                setIsLoading(true);

                const currentProposalId = localStorage.getItem('currentProposalId');

                if (!currentProposalId) {
                    console.error('Proposal ID missing');
                    setNotification({
                        show: true,
                        type: 'error',
                        message: 'Proposal ID missing. Please select a project first.'
                    });
                    return;
                }

                // Add proper error handling for API calls
                let generalRes = null;
                let privateRes = null;

                try {
                    generalRes = await apiService.getAllGeneralObjections(currentProjectId, currentProposalId);
                } catch (error) {
                    console.error('Error fetching general objections:', error);
                    generalRes = { data: [] }; // Fallback to empty array
                }

                try {
                    privateRes = await apiService.getAllPrivateObjections(currentProjectId, currentProposalId);
                } catch (error) {
                    console.error('Error fetching private objections:', error);
                    privateRes = { data: [] }; // Fallback to empty array
                }

                // Safe data extraction with fallbacks
                const generalData = generalRes?.data || generalRes || [];
                const privateData = privateRes?.data || privateRes || [];

                // Ensure we're working with arrays
                const safeGeneralData = Array.isArray(generalData) ? generalData : [];
                const safePrivateData = Array.isArray(privateData) ? privateData : [];

                const general = safeGeneralData.map((item, index) => ({
                    id: `G${item.objection_id || index}`,
                    type: 'General',
                    name: item.objector_name || 'Unknown',
                    date: item.objection_date,
                    status: item.OBJECTION_STATUS || 'Pending',
                    project: item.project_name || `Project ${item.project_id || 'Unknown'}`,
                    address: item.objector_address,
                    phone: item.objector_contact,
                    description: item.objection_summary,
                    objectionDetails: item.objection_details || '',   // ✅ added
                    caseNo: item.case_no,
                    affectedSurveyNo: item.affected_survey_no || '',   // ✅ add this
                    hearing_date: item.hearing_date,
                    fullData: item
                }));

                const privateObjs = safePrivateData.map((item, index) => ({
                    id: `P${item.pobjection_id || index}`,
                    type: 'Private',
                    name: item.owner_name || 'Unknown',
                    date: item.objection_date,
                    status: item.OBJECTION_STATUS || 'Pending',
                    project: item.project_name || `Project ${item.project_id || 'Unknown'}`,
                    address: item.owner_address,
                    phone: item.owner_contact,
                    description: item.objection_summary,
                    caseNo: item.case_no,
                    affectedSurveyNo: item.affected_survey_no || '',   // ✅ add this
                    hearing_date: item.hearing_date,
                    fullData: item
                }));

                const combined = [...general, ...privateObjs];
                setObjections(combined);

                // Show appropriate message based on results
                if (combined.length === 0) {
                    setNotification({
                        show: true,
                        type: 'info',
                        message: 'No objections found for this project'
                    });
                } else {
                    setNotification({
                        show: true,
                        type: 'success',
                        message: `Loaded ${combined.length} objections successfully`
                    });
                }

            } catch (error) {
                console.error('Error loading objections:', error);
                setNotification({
                    show: true,
                    type: 'error',
                    message: 'Failed to load objections. Please try again.'
                });
                // Set empty array as fallback
                setObjections([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAllObjections();
    }, [currentProjectId]);


    useEffect(() => {
        if (showSendToSamanvayModal) {
            fetchusersSamanvay();
        }
    }, [showSendToSamanvayModal]);

    const getDownloadData = () =>
        sortedObjections.map((obj, index) => ({
            serialNumber: index + 1,
            objectorName: obj.name || 'N/A',
            address: obj.address || 'N/A',
            objectionDate: obj.date ? new Date(obj.date).toLocaleDateString('en-GB') : 'N/A',
            caseNumber: obj.affectedSurveyNo || obj.caseNo || 'N/A',  // ✅ now pulls correctly
            objectionDetails: obj.objectionDetails || obj.description || 'N/A',
            hearingDate: obj.hearing_date ? new Date(obj.hearing_date).toLocaleDateString('en-GB') : 'N/A',
            officerDecision: obj.fullData?.hearing_outcome || 'N/A'
        }));

    const getDownloadColumns = () => [
        { header: 'अनुक्रमांक', key: 'serialNumber', width: 5 },
        { header: 'अर्जदार यांचे नाव', key: 'objectorName', width: 40 },
        { header: 'पत्ता', key: 'address', width: 25 },
        { header: 'हरकत अर्ज दिनांक', key: 'objectionDate', width: 15 },
        { header: 'गट क्रमांक', key: 'caseNumber', width: 5 },
        { header: 'हरकतीचा तपशील', key: 'objectionDetails', width: 40 },
        { header: 'सुनावणी दिनांक', key: 'hearingDate', width: 10 },
        { header: 'भूसंपादन अधिकारी यांचा निर्णय', key: 'officerDecision', width: 30 }
    ];

    const handlePrint = () => {
        // get proposal name (robust fallback keys)
        const selectedProposal = JSON.parse(localStorage.getItem("selectedProposal") || "{}");
        const proposalName = selectedProposal.section_11_bhusampadan_no || '';

        const columns = [
            "अनुक्रमांक",
            "अर्जदार यांचे नाव",
            "पत्ता",
            "हरकत अर्ज दिनांक",
            "गट क्रमांक",
            "हरकतीचा तपशील",
            "सुनावणी दिनांक",
            "भूसंपादन अधिकारी यांचा निर्णय"
        ];

        const rows = getDownloadData().map((row, index) => [
            index + 1,
            row.objectorName || "",
            row.address || "",
            row.objectionDate || "",
            row.caseNumber || "",
            row.objectionDetails || "",
            row.hearingDate || "",
            row.officerDecision || ""
        ]);

        // Create HTML table dynamically
        const tableHtml = `
    <html>
      <head>
        <meta charset="UTF-8" />
          <style>
          @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
        }
      h2, h3 { text-align: center; margin: 5px 0; }
      table { border-collapse: collapse; width: 100%; margin-top: 15px; }
      th, td { border: 1px solid #000; padding: 6px; text-align: center; }
    </style>
  </head>
      <body>
        <h2>कलम 11(1) खालील प्रारंभिक अधिसूचनेवर हरकत दाखल करणाऱ्यांची यादी</h2>
            ${proposalName ? `<h3 style="text-align:center; margin-top:6px; font-weight:600;">भूसंपादन प्रकरण क्र.: ${proposalName}</h3>` : ''}
        <table>
          <thead>
            <tr>${columns.map(c => `<th>${c}</th>`).join("")}</tr>
          </thead>
          <tbody>
            ${rows.map(r => `<tr>${r.map(c => `<td>${c}</td>`).join("")}</tr>`).join("")}
          </tbody>
        </table>
      </body>
    </html>
  `;

        // Open new window for print
        const printWindow = window.open("", "_blank");
        printWindow.document.write(tableHtml);
        printWindow.document.close();
        printWindow.print();
    };

    const handleRaiseObjection = () => {
        setSubComponent("GeneralObjectionForm");
    };
    const handleSection15 = () => {
        setSubComponent("Section15");
    };
    const handleSection15Notice = () => {
        setSubComponent("Section15Notice");
    };

    // Close dropdowns when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (downloadRef.current && !downloadRef.current.contains(event.target)) {
                setIsDownloadOpen(false);
            }
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Auto-hide notifications after 3 seconds
    useEffect(() => {
        if (notification.show) {
            const timer = setTimeout(() => {
                setNotification({ ...notification, show: false });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [notification]);

    const filteredObjections = objections.filter(obj => {
        const matchesSearch =
            obj.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            obj.project.toLowerCase().includes(searchTerm.toLowerCase()) ||
            obj.id.toString().includes(searchTerm.toLowerCase()) ||
            (obj.description && obj.description.toLowerCase().includes(searchTerm.toLowerCase()));

        const matchesStatus = filterStatus === '' || obj.status === filterStatus;

        // Filter by tab
        const matchesTab =
            activeTab === 'all' ||
            (activeTab === 'general' && obj.type === 'General') ||
            (activeTab === 'private' && obj.type === 'Private');

        return matchesSearch && matchesStatus && matchesTab;
    });

    // Sort objections
    const sortedObjections = React.useMemo(() => {
        let sortableItems = [...filteredObjections];
        if (sortConfig.key) {
            sortableItems.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [filteredObjections, sortConfig]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortDirectionIcon = (name) => {
        if (sortConfig.key !== name) {
            return (
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                </svg>
            );
        }

        return sortConfig.direction === 'ascending' ? (
            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
        ) : (
            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
        );
    };

    const handleViewDetails = async (type, obj) => {
        try {
            setIsLoading(true);

            let response;
            let numericId = obj.id.replace(/^[G|P]/, '');

            if (type === 'Private') {
                response = await apiService.getPrivateObjectionById(numericId);
            } else {
                response = await apiService.getGeneralObjectionById(numericId);
            }

            const objectionData = response?.data || response;
            objectionData.id = obj.id;           // required by handleHearing
            objectionData.status = obj.status; // ✅ ADD THIS
            objectionData.type = obj.type;       // required by handleHearing
            // objectionData.case_no = obj.case_no;

            setDetailsData(objectionData);
            setShowDetailsModal(true);

            setNotification({
                show: true,
                type: 'success',
                message: 'Objection details loaded successfully'
            });

        } catch (error) {
            console.error('Error fetching objection details:', error);
            setNotification({
                show: true,
                type: 'error',
                message: 'Failed to load objection details'
            });
        } finally {
            setIsLoading(false);
        }
    };
    const handleViewDocument = (urlOrFile) => {
        if (!urlOrFile) return;

        let url;
        let isPdf;

        if (urlOrFile instanceof File) {
            url = URL.createObjectURL(urlOrFile);
            isPdf = urlOrFile.type === 'application/pdf';
        } else { // Assuming it's a URL string from backend
            url = urlOrFile;
            isPdf = urlOrFile.toLowerCase().includes('.pdf');
        }

        setFileUrlToView(url);
        setIsPDFToView(isPdf);
        setShowDocumentViewer(true);
    };
    const handleHearing = (objection) => {
        if (!objection) {
            console.error('No objection data provided');
            return;
        }

        let objectionId = null;
        let objectionType = 'General';

        if (objection.type === 'Private') {
            objectionId = objection.id.replace(/^P/, '');
            objectionType = 'Private';
        } else {
            objectionId = objection.id.replace(/^G/, '');
            objectionType = 'General';
        }

        const hearingData = {
            objectionId: objectionId,
            objectionType: objectionType,
            objectorName: objection.name,
            objectionDetails: objection.description,
            caseNumber: objection.id,
            fullObjectionData: objection
        };

        localStorage.setItem('selectedObjection', JSON.stringify(objection));
        localStorage.setItem('hearingData', JSON.stringify(hearingData));

        // navigateTo('hearing', hearingData);
    };



    const fetchBackToLAODate = async () => {
        try {
            if (!currentProjectId || !currentProposalId) return;
            const response = await apiService.getfetchLAOPublishButton(currentProjectId, currentProposalId);
            // Check status and if data exists
            if (response.status === 200 && response.data.length > 0) {
                const fetchedStartDate = response.data[0].cre_usr_dt; // e.g., "2025-09-13T08:48:47.620Z"
                // Convert to YYYY-MM-DD for <input type="date">
                const formattedDate = new Date(fetchedStartDate).toISOString().split("T")[0];
                setStartDate(formattedDate); // Store the date in state
            }
        } catch (error) {
            console.error("Error fetching start date:", error);
        }
    };
    // Call fetchBackToLAODate on component mount or when the project/proposal ID changes
    useEffect(() => {
        fetchBackToLAODate();
    }, [currentProjectId, currentProposalId]);

    // const selectedProposal = JSON.parse(localStorage.getItem("selectedProposal") || "{}");
    // const noticeDate = selectedProposal?.section11_rehabilitation_rights_notice
    //     ? new Date(selectedProposal.section11_rehabilitation_rights_notice)
    //     : null;

    let isObjectionAllowed = true;
    let expiryDate = null;

    if (startDate) {
        expiryDate = new Date(startDate);
        expiryDate.setDate(expiryDate.getDate() + 60); // add 60 days
        isObjectionAllowed = new Date() <= expiryDate;
    }

    const renderObjectionTable = () => {
        return (
            <>
                {/* Objection List Table */}
                {sortedObjections.length > 0 ? (
                    <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-lg hover:shadow-xl transition-shadow duration-300">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    {/* <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                        onClick={() => requestSort('caseNo')}
                                    >
                                        <div className="flex items-center space-x-1">
                                            <span>{translations[language].CASE_NO}</span>
                                            {getSortDirectionIcon('caseNo')}
                                        </div>
                                    </th> */}
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        {translations[language].ACTIONS}
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                        onClick={() => requestSort('date')}
                                    >
                                        <div className="flex items-center space-x-1">
                                            <span>{translations[language].DATE}</span>
                                            {getSortDirectionIcon('date')}
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                        onClick={() => requestSort('name')}
                                    >
                                        <div className="flex items-center space-x-1">
                                            <span>{translations[language].OBJECTOR}</span>
                                            {getSortDirectionIcon('name')}
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                                        onClick={() => requestSort('status')}
                                    >
                                        <div className="flex items-center space-x-1">
                                            <span>{translations[language].STATUS}</span>
                                            {getSortDirectionIcon('status')}
                                        </div>
                                    </th>

                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {sortedObjections.map((obj) => (
                                    <tr key={obj.id} className="hover:bg-gray-50 transition-colors duration-150">
                                        {/* 1 */}
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                            <div className="flex space-x-2">
                                                <button
                                                    className="bg-blue-50 text-blue-700 hover:bg-blue-100 px-3 py-1 rounded-md transition duration-150 flex items-center shadow hover:shadow-md"
                                                    onClick={async () => {
                                                        setLoadingId(obj.id);   // mark only this row as loading
                                                        try {
                                                            await handleViewDetails(obj.type, obj);
                                                        } finally {
                                                            setLoadingId(null);   // reset after done
                                                        }
                                                    }}
                                                    disabled={loadingId === obj.id}
                                                >
                                                    {loadingId === obj.id ? (
                                                        <RefreshCw className="h-4 w-4 mr-1 animate-spin" />
                                                    ) : (
                                                        <svg
                                                            className="h-4 w-4 mr-1"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                            />
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                            />
                                                        </svg>
                                                    )}
                                                    {/* {translations[language].View} */}
                                                </button>

                                                {/* <button
                                                    className="bg-purple-50 text-purple-700 hover:bg-purple-100 px-3 py-1 rounded-md transition duration-150 flex items-center shadow hover:shadow-md"
                                                    onClick={() => handleHearing(obj)}
                                                >
                                                    <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                    </svg>
                                                    {translations[language].Hearing}
                                                </button> */}

                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {new Date(obj.date).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric'
                                            })}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center">
                                                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold">
                                                    {obj.name.charAt(0)}
                                                </div>
                                                <div className="ml-4">
                                                    <div className="text-sm font-medium text-gray-900">{obj.name}</div>
                                                    <div className="text-sm text-gray-500">{obj.phone}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            {editingStatusId === obj.id && userRole === 3 ? (
                                                <div className="flex flex-col space-y-2">
                                                    {/* Dropdown for decision */}
                                                    <select
                                                        className="border rounded px-2 py-1 text-sm"
                                                        onChange={(e) => {
                                                            if (e.target.value === "Completed") {
                                                                // Show date picker
                                                            }
                                                        }}
                                                    >
                                                        <option value="">Select decision</option>
                                                        <option value="Completed">Mark Completed</option>
                                                        <option value="Reject">Mark Incomplet</option>
                                                    </select>

                                                    {/* Date picker */}
                                                    <input
                                                        type="date"
                                                        className="border rounded px-2 py-1 text-sm"
                                                        value={selectedDecisionDate}
                                                        onChange={(e) => setSelectedDecisionDate(e.target.value)}
                                                    />
                                                    <div className="flex space-x-2">
                                                        {/* Save button */}
                                                        <button
                                                            disabled={!selectedDecisionDate || savingId === obj.id}
                                                            className="bg-green-500 text-white px-3 py-1 text-xs rounded flex items-center justify-center"
                                                            onClick={async () => {
                                                                setSavingId(obj.id); // start loader
                                                                try {
                                                                    const numericId = obj.id.replace(/^G|P/, ''); // Strip G/P
                                                                    console.log("PATCH CALL:", numericId, selectedDecisionDate);

                                                                    await apiService.patchUpdateGeneralObjection(numericId, {
                                                                        OBJECTION_STATUS: "Completed",
                                                                        hearing_date: selectedDecisionDate,
                                                                    });

                                                                    // Update UI correctly
                                                                    const updated = objections.map((o) => {
                                                                        const oNumeric = o.id.replace(/^G|P/, "");
                                                                        const currentNumeric = obj.id.replace(/^G|P/, "");

                                                                        return oNumeric === currentNumeric
                                                                            ? { ...o, status: "Completed", hearing_date: selectedDecisionDate }
                                                                            : o;
                                                                    });
                                                                    setObjections(updated);
                                                                    setEditingStatusId(null);

                                                                    // Success notification
                                                                    setNotification({
                                                                        show: true,
                                                                        type: "success",
                                                                        message: "Status updated successfully",
                                                                    });
                                                                } catch (err) {
                                                                    console.error(err);

                                                                    // Error notification
                                                                    setNotification({
                                                                        show: true,
                                                                        type: "error",
                                                                        message: "Failed to update status",
                                                                    });
                                                                } finally {
                                                                    setSavingId(null); // stop loader
                                                                }
                                                            }}
                                                        >
                                                            {savingId === obj.id ? (
                                                                <>
                                                                    <RefreshCw className="h-3 w-3 mr-1 animate-spin" /> Saving...
                                                                </>
                                                            ) : (
                                                                "Save"
                                                            )}
                                                        </button>

                                                        {/* Cancel button */}
                                                        <button
                                                            className="bg-gray-300 text-gray-800 px-3 py-1 text-xs rounded"
                                                            onClick={() => {
                                                                setSelectedDecisionDate(""); // clear selection
                                                                setEditingStatusId(null);   // close edit mode
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <span
                                                    onClick={() => {
                                                        // Only allow editing if user is LAO (role 3) and status is Pending
                                                        if (obj.status === "Pending" && userRole === 3) {
                                                            setEditingStatusId(obj.id);
                                                        }
                                                    }}
                                                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${obj.status === "Pending"
                                                        ? userRole === 3
                                                            ? "bg-yellow-100 text-yellow-800 cursor-pointer hover:bg-yellow-200 transition-colors"
                                                            : "bg-yellow-100 text-yellow-800"
                                                        : obj.status === "Completed"
                                                            ? "bg-blue-100 text-blue-800"
                                                            : obj.status === "Reject" || obj.status === "Rejected"
                                                                ? "bg-red-100 text-red-800"
                                                                : "bg-gray-100 text-gray-800"
                                                        }`}
                                                    title={
                                                        obj.status === "Pending" && userRole !== 3
                                                            ? "Only LAO can update status"
                                                            : obj.status === "Pending" && userRole === 3
                                                                ? "Click to update status"
                                                                : ""
                                                    }
                                                >
                                                    {obj.status === "Completed" && obj.hearing_date
                                                        ? `${obj.status} (${new Date(obj.hearing_date).toLocaleDateString("en-GB")})`
                                                        : obj.status}
                                                </span>
                                            )}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center shadow-md hover:shadow-lg transition-shadow duration-300">
                        <svg className="mx-auto h-16 w-16 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <h3 className="mt-4 text-xl font-medium text-gray-900">{translations[language].NOF}</h3>
                        <p className="mt-2 text-base text-gray-500">
                            {translations[language].TAYF}
                        </p>
                        <div className="mt-6">
                            <button
                                onClick={() => {
                                    setSearchTerm('');
                                    setFilterStatus('');
                                    setActiveTab('all');
                                }}
                                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-gray-900 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300"
                            >
                                <svg className="h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                {translations[language].Clear_all_filters}
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    };

    // Main list view with tabs
    const renderListView = () => {
        return (
            <>
                {/* Notification System */}
                {notification.show && (
                    <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg max-w-md z-50 flex items-center ${notification.type === 'success' ? 'bg-green-100 border-l-4 border-green-500 text-green-700' :
                        notification.type === 'error' ? 'bg-red-100 border-l-4 border-red-500 text-red-700' :
                            'bg-blue-100 border-l-4 border-blue-500 text-blue-700'
                        } transform transition-transform duration-300 animate-slideInRight`}>
                        <div className="mr-3">
                            {notification.type === 'success' ? (
                                <svg className="h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            ) : notification.type === 'error' ? (
                                <svg className="h-6 w-6 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            )}
                        </div>
                        <div>
                            <p className="font-bold">
                                {notification.type === 'success' ? 'Success!' :
                                    notification.type === 'error' ? 'Error!' : 'Info'}
                            </p>
                            <p>{notification.message}</p>
                        </div>
                        <button
                            onClick={() => setNotification({ ...notification, show: false })}
                            className="ml-auto text-gray-600 hover:text-gray-800"
                        >
                            <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                )}

                {/* Header with enhanced gradient and visual design */}
                <div className="relative mb-8 bg-white p-6 rounded-xl overflow-hidden border border-gray-200 shadow-md animate-fadeIn">
                    <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full filter blur-3xl opacity-40"></div>
                    <div className="absolute bottom-0 left-0 w-40 h-40 bg-gradient-to-tr from-blue-100 to-blue-200 rounded-full filter blur-3xl opacity-40"></div>

                    <div className="relative z-10 flex items-center justify-between">
                        <div>
                            <h1 className="text-2xl font-bold text-transparent bg-gradient-to-r from-blue-800 to-blue-600 bg-clip-text">
                                {translations[language].Objection_Management_System}</h1>
                            <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mt-1">
                                {currentProjectName && (
                                    <p className="text-sm text-gray-700 font-medium">
                                        {translations[language].Project}: {currentProjectName}
                                    </p>
                                )}
                                {currentProjectId && (
                                    <p className="text-xs text-gray-500">
                                        {translations[language].ID}: {currentProjectId}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content area with improved design */}
                <div className="bg-white rounded-b-lg shadow-lg">
                    {/* Tab Navigation */}


                    {/* Tab Content */}
                    <div className="p-6">
                        {/* Enhanced search and filter bar */}
                        <div className="mb-6 animate-slideInLeft" style={{ animationDelay: '200ms' }}>
                            <div className="flex flex-col lg:flex-row gap-4">
                                {/* Search bar */}
                                <div className="flex-1 flex flex-col md:flex-row gap-3">
                                    <div className="relative w-full md:w-80 group">
                                        <input
                                            type="text"
                                            placeholder={translations[language].SearchObjections}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="w-full pl-10 pr-4 py-3 rounded-xl bg-white border border-gray-200 text-gray-700 placeholder-gray-400 
                                            focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 
                                            transition-all duration-200 shadow-sm group-hover:border-gray-300"
                                        />
                                        <div className="absolute left-3 top-3 text-gray-400 group-hover:text-gray-600 transition-colors duration-200">
                                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                            </svg>
                                        </div>
                                        {searchTerm && (
                                            <button
                                                onClick={() => setSearchTerm('')}
                                                className="absolute right-3 top-3 text-gray-400 hover:text-gray-600"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </button>
                                        )}
                                    </div>

                                    {/* Filter Button */}
                                    {/* <div className="relative" ref={filterRef}>
                                        <button
                                            onClick={() => setIsFilterOpen(!isFilterOpen)}
                                            className={`px-4 py-3 text-sm rounded-xl flex items-center space-x-2 transition-all duration-200 group
                                            ${isFilterOpen ?
                                                    'bg-blue-50 text-blue-700 border border-blue-200' :
                                                    'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 hover:text-gray-800'}`}
                                        >
                                            <div className="relative">
                                                <svg className={`h-6 w-5 transition-transform duration-300 ${isFilterOpen ? ' scale-110' : ''}`}
                                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                                                </svg>
                                                <div className={`absolute inset-0 bg-blue-500 rounded-full blur opacity-0 
                                                    ${isFilterOpen ? 'opacity-10' : 'group-hover:opacity-10'} transition-opacity duration-200`}></div>
                                            </div>
                                            <span>{translations[language].Filter_Status}</span>
                                            <svg className={`h-4 w-4 transition-transform duration-300 ${isFilterOpen ? 'rotate-180' : ''}`}
                                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </button>


                                    </div> */}
                                </div>
                                {/* Section15 */}
                                {/* {userRole === ROLES.LAO && (

                                    <button
                                        onClick={() => {
                                            if (isObjectionAllowed) {
                                                handleRaiseObjection();
                                            }
                                        }}
                                        disabled={!isObjectionAllowed}
                                        className={`flex items-center px-4 py-2 rounded-lg transition-all duration-200 shadow-lg ${isObjectionAllowed
                                            ? "bg-gradient-to-r from-green-600 to-green-700 text-white hover:from-green-700 hover:to-green-800 shadow-green-200"
                                            : "bg-gray-400 text-gray-200 cursor-not-allowed"
                                            }`}
                                        title={
                                            !isObjectionAllowed && expiryDate
                                                ? `${translations[language].LastDateWarning} ${expiryDate.toLocaleDateString("en-GB")})`
                                                : ""
                                        }
                                    >
                                        <Plus className="mr-2 h-4 w-4" />
                                        {translations[language].RaiseObjection}
                                    </button>
                                )} */}

                                {/* {userRole === ROLES.LAO && ( */}
                                {/* Data Entry */}
                                {/* {userRole === ROLES.LAO && (
                                    <button
                                        onClick={handleRaiseObjection}
                                        disabled={!startDate || !isObjectionAllowed}
                                        className={`flex items-center px-4 py-2 rounded-lg transition-all duration-200 shadow-lg 
      bg-gradient-to-r from-green-600 to-green-700 text-white 
      hover:from-green-700 hover:to-green-800 shadow-green-200
      ${(!startDate || !isObjectionAllowed) ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                                        title={
                                            !startDate
                                                ? "Proposal is not published yet. Please wait until it is published."
                                                : !isObjectionAllowed
                                                    ? "Objection period has expired."
                                                    : ""
                                        }
                                    >
                                        <Plus className="mr-2 h-4 w-4" />
                                        {translations[language].RaiseObjection}
                                    </button>
                                )} */}
                                {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (
                                    <button
                                        onClick={handleRaiseObjection}
                                        disabled={
                                            userRole !== ROLES.DATA_ENTRY && (!startDate || !isObjectionAllowed)
                                        }
                                        className={`flex items-center px-4 py-2 rounded-lg transition-all duration-200 shadow-lg 
  bg-gradient-to-r from-green-600 to-green-700 text-white 
  hover:from-green-700 hover:to-green-800 shadow-green-200
  ${userRole !== ROLES.DATA_ENTRY && (!startDate || !isObjectionAllowed)
                                                ? "opacity-50 cursor-not-allowed"
                                                : "cursor-pointer"
                                            }`}
                                        title={
                                            userRole === ROLES.DATA_ENTRY
                                                ? ""
                                                : !startDate
                                                    ? "Proposal is not published yet. Please wait until it is published."
                                                    : !isObjectionAllowed
                                                        ? "Objection period has expired."
                                                        : ""
                                        }
                                    >
                                        <Plus className="mr-2 h-4 w-4" />
                                        {translations[language].RaiseObjection}
                                    </button>

                                )}
                                {/* Section15 and Section15Notice Buttons */}
                                <button
                                    onClick={handleSection15Notice}
                                    className="inline-flex items-center px-4 py-2 border border-transparent 
                                                rounded-md shadow-sm text-sm font-medium text-white 
                                                bg-gradient-to-r from-blue-600 to-indigo-700 
                                                hover:from-blue-700 hover:to-indigo-800 
                                                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 
                                                transition-all duration-200"
                                >
                                    <FileText className="h-4 w-4 mr-2" />
                                    {translations[language].Section15Notice}
                                </button>

                                <button
                                    onClick={handleSection15}
                                    className="inline-flex items-center px-4 py-2 border border-transparent 
                                                rounded-md shadow-sm text-sm font-medium text-white 
                                                bg-gradient-to-r from-blue-600 to-indigo-700 
                                                hover:from-blue-700 hover:to-indigo-800 
                                                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 
                                                transition-all duration-200"
                                >
                                    <FileText className="h-4 w-4 mr-2" />
                                    {translations[language].Section15}
                                </button>

                                {/*Login LAO - Send to Samanvay Button */}
                                {userRole === ROLES.LAO && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (buttonDisabled) {
                                                showConfirm(
                                                    translations[language]?.confirmResubmission,
                                                    translations[language]?.resubmissionWarning,
                                                    () => {
                                                        // what should happen on confirm
                                                        setshowSendToSamanvayModal(true);
                                                    },
                                                    () => {
                                                        // optional cancel callback
                                                        console.log("Resend cancelled");
                                                    },
                                                    "danger" // modal color type
                                                );
                                            } else {
                                                setshowSendToSamanvayModal(true);
                                            }
                                        }}
                                        className={`flex items-center px-4 py-2 rounded-lg transition-colors ${isSamanvaySent
                                            ? "bg-red-600 text-white hover:bg-red-700"
                                            : "bg-purple-600 text-white hover:bg-purple-700"
                                            }`}
                                        title={
                                            isSamanvaySent
                                                ? translations[language]?.AlreadySentToSamanvayOfficerClickToResend
                                                : translations[language]?.SendToSamanvayOfficer
                                        }
                                    >
                                        <Send className="mr-2 h-4 w-4" />
                                        <span>{translations[language]?.SendToSamanvayOfficer}</span>
                                    </button>
                                )}

                                {/*Login Samanvay - Send to Collector */}
                                {userRole === ROLES.SAMANVAY && (
                                    <>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (buttonDisabled) {
                                                    showConfirm(
                                                        translations[language]?.confirmResubmission,
                                                        translations[language]?.resubmissionWarning,
                                                        () => {
                                                            // what should happen on confirm
                                                            setshowSendToCollectorModal(true);
                                                        },
                                                        () => {
                                                            // optional cancel callback
                                                            console.log("Resend cancelled");
                                                        },
                                                        "danger" // modal color type
                                                    );
                                                } else {
                                                    setshowSendToCollectorModal(true);
                                                }
                                            }}
                                            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                                ? "bg-red-600 text-white hover:bg-red-700"
                                                : "bg-purple-600 text-white hover:bg-purple-700"
                                                }`}
                                            title={
                                                buttonDisabled
                                                    ? translations[language]?.SendToCollectorAlreadySentClickToResend
                                                    : translations[language]?.SendToCollector
                                            }
                                        >
                                            <Send className="mr-2 h-4 w-4" />
                                            <span>{translations[language]?.SendToCollector}</span>
                                        </button>
                                    </>
                                )}

                                {userRole === ROLES.COLLECTOR && (
                                    <>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (buttonDisabled) {
                                                    showConfirm(
                                                        translations[language]?.confirmResubmission,
                                                        translations[language]?.resubmissionWarning,
                                                        () => {
                                                            // what should happen on confirm
                                                            setshowSendToLAOModal(true);
                                                        },
                                                        () => {
                                                            // optional cancel callback
                                                            console.log("Resend cancelled");
                                                        },
                                                        "danger" // modal color type
                                                    );
                                                } else {
                                                    setshowSendToLAOModal(true);
                                                }
                                            }}
                                            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                                ? "bg-red-600 text-white hover:bg-red-700"
                                                : "bg-purple-600 text-white hover:bg-purple-700"
                                                }`}
                                            title={
                                                buttonDisabled
                                                    ? translations[language]?.AlreadySentBackToLAOClickToResend
                                                    : translations[language]?.sendToLAO
                                            }
                                        >
                                            <Send className="mr-2 h-4 w-4" />
                                            <span>{translations[language]?.sendToLAO}</span>
                                        </button>

                                    </>
                                )}

                                {/* Download Options Button */}
                                <button
                                    onClick={handlePrint}
                                    className="flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50"
                                >
                                    <Download className="mr-1 h-4 w-4" /> {translations[language].export}
                                </button>

                            </div>
                        </div>

                        {/* Results counter and stats */}
                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 p-3 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
                            <div className="text-sm text-gray-600 mb-2 md:mb-0">
                                <span className="font-medium">{translations[language].Showing} {sortedObjections.length} {translations[language].Of} {objections.length} {translations[language].Objections}</span>
                                {(searchTerm || filterStatus || activeTab !== 'all') &&
                                    <button
                                        className="ml-2 text-blue-600 hover:text-blue-800 underline"
                                        onClick={() => {
                                            setSearchTerm('');
                                            setFilterStatus('');
                                            setActiveTab('all');
                                        }}
                                    >
                                        {translations[language].Clear_all_filters}
                                    </button>
                                }
                            </div>
                            <div className="flex gap-4">
                                <div className="flex items-center">
                                    <span className="inline-block w-3 h-3 bg-yellow-300 rounded-full mr-2"></span>
                                    <span className="text-sm">{translations[language].pending}: {objections.filter(o => o.status === 'Pending').length}</span>
                                </div>
                                <div className="flex items-center">
                                    <span className="inline-block w-3 h-3 bg-green-400 rounded-full mr-2"></span>
                                    <span className="text-sm">{translations[language].completed}: {objections.filter(o => o.status === 'Completed').length}</span>
                                </div>
                            </div>
                        </div>

                        {/* Render the table */}
                        {renderObjectionTable()}

                        {/* Pagination */}
                        {sortedObjections.length > 0 && (
                            <div className="flex items-center justify-between mt-6">
                                <div className="flex-1 flex justify-between sm:hidden">
                                    <button className="relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 border border-gray-300 transition duration-150">
                                        {translations[language].Previous}
                                    </button>
                                    <button className="ml-3 relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 border border-gray-300 transition duration-150">
                                        {translations[language].Next}
                                    </button>
                                </div>
                                <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                                    <div>
                                        <p className="text-sm text-gray-700">
                                            {translations[language].Showing} <span className="font-medium">1</span> {translations[language].to} <span className="font-medium">{sortedObjections.length}</span> {translations[language].of}{' '}
                                            <span className="font-medium">{sortedObjections.length}</span> {translations[language].results}
                                        </p>
                                    </div>
                                    <div>
                                        <nav className="relative z-0 inline-flex rounded-md shadow-sm" aria-label="Pagination">
                                            <button className="relative inline-flex items-center px-3 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 transition duration-150">
                                                <span className="sr-only">{translations[language].Previous}</span>
                                                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                                                </svg>
                                            </button>
                                            <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-blue-50 text-sm font-medium text-blue-600 hover:bg-blue-100 transition duration-150">
                                                1
                                            </button>
                                            <button className="relative inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 transition duration-150">
                                                <span className="sr-only">{translations[language].Next}</span>
                                                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                                </svg>
                                            </button>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </>
        );
    };

    // Tab content for different objection forms or views
    const renderOtherScreens = () => {
        return (
            <div className="p-6 border rounded-lg bg-white shadow-lg">

                {/* Form content */}
                <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                    <div className="mb-4">
                        <span className="text-sm text-gray-500">{translations[language].OBJECTOR}:</span>
                        <h4 className="text-lg font-medium">{selectedObjection ? selectedObjection.name : 'New Entry'}</h4>
                    </div>

                    {selectedObjection && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            <div>
                                <span className="text-sm text-gray-500">{translations[language].PROJECT}:</span>
                                <p>{selectedObjection.project}</p>
                            </div>
                            <div>
                                <span className="text-sm text-gray-500">{translations[language].STATUS}:</span>
                                <p className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mt-1 ${selectedObjection.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                    selectedObjection.status === 'Scheduled' ? 'bg-blue-100 text-blue-800' :
                                        selectedObjection.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                            'bg-red-100 text-red-800'
                                    }`}>
                                    {selectedObjection.status}
                                </p>
                            </div>
                            <div>
                                <span className="text-sm text-gray-500">{translations[language].address}:</span>
                                <p>{selectedObjection.address}</p>
                            </div>
                            <div>
                                <span className="text-sm text-gray-500">{translations[language].Phone}:</span>
                                <p>{selectedObjection.phone}</p>
                            </div>
                            <div className="md:col-span-2">
                                <span className="text-sm text-gray-500">{translations[language].description}:</span>
                                <p>{selectedObjection.description}</p>
                            </div>
                        </div>
                    )}


                </div>
            </div>
        );
    };

    // Restore modal state from parameters
    useEffect(() => {
        if (shouldRestoreModal && modalParams) {

            setshowSendToCollectorModal(true);
            fetchUsersAllCollector();

            // Restore previous selections
            pendingRestore.current = {
                user: modalParams.selectedUser || '',
                remarks: modalParams.remarks || '',
            };

            // Set COLLECTOR remarks, not Samanvay remarks
            setremarksCollector(modalParams.remarks || '');

            // Reset flag so modal doesn't restore again automatically
            if (setShouldRestoreModal) {
                setShouldRestoreModal(false);
            }
        }
    }, [shouldRestoreModal, modalParams, setShouldRestoreModal]);

    useEffect(() => {
        if (pendingRestore.current) {
            if (usersCollectorAll.length > 0) {
                setselectedUserCollector(pendingRestore.current.user);
                setremarksCollector(pendingRestore.current.remarks);

                pendingRestore.current = null; // clear after applying
            }
        }
    }, [usersCollectorAll]);

    const pendingRestore = useRef(null);

    // Navigate to covering letters with modal state
    const handleCoveringLetterClick = () => {
        console.log('handleCoveringLetterClick called');
        console.log('onNavigateWithModal type:', typeof onNavigateWithModal);

        // Add validation
        if (typeof onNavigateWithModal !== 'function') {
            console.error('onNavigateWithModal is not a function:', onNavigateWithModal);
            alert('Navigation function is not available. Please check the component props.');
            return;
        }

        const modalState = {
            selectedUser: selectedUserCollector,
            userId: selectedUserCollector,
            remarks: remarksCollector,
            selectedDocumentName: selectedDocumentCollector?.name || null,
            timestamp: new Date().getTime()
        };

        console.log('Modal state for covering letters:', modalState);

        // Close the modal before navigating
        setshowSendToCollectorModal(false);

        // Use the correct component name for Section 19
        console.log('Calling onNavigateWithModal with CoveringLettersSection11');
        onNavigateWithModal('CoveringLettersSection15', modalState);
    };

    // Add this BEFORE the main return(...) so loader returns early while loadingRecords/isLoading is true
    if (loadingRecords || isLoading) {
        return (
            <div className="p-6 max-w-7xl mx-auto">
                <div className="flex justify-center items-center h-80">
                    <div className="text-center animate-float">
                        <div className="inline-flex relative">
                            <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                            <div
                                className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0"
                                style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}
                            ></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                            </div>
                        </div>
                        <p className="text-gray-400 mt-4">हरकत यादी लोड होत आहे...</p>
                    </div>
                </div>
            </div>
        );
    }


    // Main component render
    return (
        <div className="max-w-7xl mx-auto p-4">
            {activeScreen === 'list' ? renderListView() : renderOtherScreens()}
            <DownloadModal
                isOpen={isDownloadOpen}
                onClose={() => setIsDownloadOpen(false)}
                title={translations[language].objectionList}
                data={getDownloadData()}
                columns={getDownloadColumns()}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                screenName="EnhancedObjectionList"
            />
            {renderDetailsModal()}
            {renderImageModal()}

            {/* Send to Samanvay Modal */}
            {showSendToSamanvayModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* Header */}
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-xl font-semibold text-gray-800">
                                    {translations[language]?.SendToSamanvayOfficer || 'Send to Samanvay Officer'}
                                </h3>
                                <button
                                    onClick={() => {
                                        setshowSendToSamanvayModal(false);
                                        setselectedDocumentSamanvay(null);
                                        resetSignatureState();
                                    }}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <X className="h-6 w-6" />
                                </button>
                            </div>

                            <div className="space-y-4">
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.selectUserSamanvayOfficer || 'Select Samanvay Officer'} *
                                    </label>
                                    <select
                                        value={selectedUserSamanvay}
                                        onChange={(e) => setselectedUserSamanvay(e.target.value)}
                                        disabled={loadingusersSamanvay}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingusersSamanvay ?
                                                (translations[language]?.LoadingUsers || 'Loading users...') :
                                                (translations[language]?.SelectUser || 'Select User')
                                            }
                                        </option>
                                        {usersSamanvay.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role || user.user_role || 'Samanvay Officer'})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks || 'Remarks'}
                                    </label>
                                    <textarea
                                        value={remarksSamanvay}
                                        onChange={(e) => setremarksSamanvay(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Upload Document *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setselectedDocumentSamanvay(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                    {selectedDocumentSamanvay && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between mb-2">
                                                <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                    Selected: {selectedDocumentSamanvay.name}
                                                </p>
                                                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                    {(selectedDocumentSamanvay.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>
                                            <div className="flex gap-2">
                                                {selectedDocumentSamanvay.type === 'application/pdf' && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (selectedDocumentSamanvay?.type === 'application/pdf') {
                                                                    setPdfForSigning(selectedDocumentSamanvay);
                                                                    setShowSignaturePad(true);
                                                                }
                                                            }}
                                                            disabled={uploadStatus === 'uploading'}
                                                            className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                        >
                                                            {uploadStatus === 'uploading' ? (
                                                                <>
                                                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                    Signing...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                    </svg>
                                                                    Sign Doc
                                                                </>
                                                            )}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleViewDocument(
                                                                uploadStatus === 'success' ? selectedSignDocument : selectedDocumentSamanvay
                                                            )}
                                                            className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                        >
                                                            <Eye className="h-3 w-3" />
                                                            View
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                            {/* Upload status messages */}
                                            {uploadStatus === 'success' && (
                                                <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                    ✅ Document signed successfully!
                                                </div>
                                            )}
                                            {uploadStatus === 'error' && uploadError && (
                                                <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                    ❌ {uploadError}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setshowSendToSamanvayModal(false);
                                        setselectedDocumentSamanvay(null);
                                        resetSignatureState();
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToSamanvay}
                                >
                                    {translations[language]?.Cancel || 'Cancel'}
                                </button>

                                <button
                                    onClick={handleSendToSamanvay}
                                    disabled={sendingToSamanvay || !selectedUserSamanvay || !selectedDocumentSamanvay} // Fixed condition
                                    className={`px-6 py-2 rounded-lg text-white font-medium shadow-md transition-colors duration-200 
        ${sendingToSamanvay || !selectedUserSamanvay || !selectedDocumentSamanvay
                                            ? 'bg-gray-400 cursor-not-allowed'
                                            : 'bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800'
                                        }`}
                                >
                                    {sendingToSamanvay ? (
                                        <>
                                            <RefreshCw className="h-4 w-4 mr-2 animate-spin inline" />
                                            Sending...
                                        </>
                                    ) : (
                                        "Send to Samanvay"
                                    )}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>)
            }

            {/* Send to Collector Modal */}
            {showSendToCollectorModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* <div className="flex justify-between items-center mb-6">
                            <h3 className="text-xl font-semibold text-gray-800">
                              {translations[language]?.SendToCollector}
                            </h3>
                            <button
                              onClick={() => setshowSendToCollectorModal(false)}
                              className="text-gray-400 hover:text-gray-600"
                            >
                              <X className="h-6 w-6" />
                            </button>
                          </div> */}

                            <div className="space-y-4">
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.SelectUserCollector}*
                                    </label>
                                    <select
                                        value={selectedUserCollector}
                                        onChange={(e) => setselectedUserCollector(e.target.value)}
                                        disabled={loadingusersCollector}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingusersCollector ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                        </option>
                                        {usersCollectorAll.map((user) => (
                                            <option key={user.usr_id} value={user.usr_id}>
                                                {user.full_name} ({user.usr_role || user.user_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks}
                                    </label>
                                    <textarea
                                        value={remarksCollector}
                                        onChange={(e) => setremarksCollector(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Upload Document *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setselectedDocumentCollector(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />

                                </div>

                                <div className="flex justify-start">
                                    <button
                                        onClick={handleCoveringLetterClick}
                                        className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                                    >
                                        कलम 15 मान्यता
                                    </button>
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setshowSendToCollectorModal(false);
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToCollector}
                                >
                                    {translations[language]?.Cancel}
                                </button>
                                <button
                                    onClick={handleSendToCollector}
                                    disabled={sendingToCollector || !selectedUserCollector || !selectedDocumentCollector}
                                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToCollector ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language]?.Sending}
                                        </>
                                    ) : (
                                        <>
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language]?.CommonSave}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Send to LAO Modal */}
            {showSendToLAOModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* <div className="flex justify-between items-center mb-6">
                            <h3 className="text-xl font-semibold text-gray-800">
                              {translations[language]?.SendBackToLAOOfficer}
                            </h3>
                            <button
                              onClick={() => setshowSendToLAOModal(false)}
                              className="text-gray-400 hover:text-gray-600"
                            >
                              <X className="h-6 w-6" />
                            </button>
                          </div> */}

                            <div className="space-y-4">
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.SelectUserLAO}*
                                    </label>
                                    <select
                                        value={selectedUserLAO}
                                        onChange={(e) => setselectedUserLAO(e.target.value)}
                                        disabled={loadingusersLAO}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingusersLAO ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                        </option>
                                        {usersLAO.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks}
                                    </label>
                                    <textarea
                                        value={remarksLAO}
                                        onChange={(e) => setremarksLAO(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Upload Document *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setselectedDocumentLAO(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                </div>

                                <div className="flex justify-start">
                                    <button
                                        onClick={handleCoveringLetterClick}
                                        className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                                    >
                                        कलम 15 मान्यता
                                    </button>
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setshowSendToLAOModal(false);
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToLAO}
                                >
                                    {translations[language]?.Cancel}
                                </button>
                                <button
                                    onClick={handleSendToLAO}
                                    disabled={sendingToLAO || !selectedUserLAO || !selectedDocumentLAO}
                                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToLAO ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language]?.Sending}
                                        </>
                                    ) : (
                                        <>
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language]?.CommonSave}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Unified Document Viewer Modal */}
            {showDocumentViewer && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-3xl w-full max-w-5xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
                        {/* Header */}
                        <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
                            <div className="flex items-center space-x-3">
                                <h3 className="text-2xl font-bold text-gray-800 tracking-tight">Document Preview</h3>
                            </div>
                            <button
                                onClick={closeDocumentViewer}
                                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold shadow-sm hover:shadow-md"
                                aria-label="Close modal"
                            >
                                ×
                            </button>
                        </div>

                        {/* Document Viewer Container */}
                        <div className="h-[calc(95vh)] flex flex-col">
                            <div className="flex-1 bg-gray-50 overflow-hidden shadow-inner border border-gray-200">
                                {/* Document Content */}
                                <div className="w-full h-full flex items-center justify-center">
                                    {isPDFToView ? (
                                        <iframe
                                            src={fileUrlToView}
                                            className="w-full h-full border-0 bg-white shadow-lg"
                                            title="PDF Preview"
                                        ></iframe>
                                    ) : (
                                        <img
                                            src={fileUrlToView}
                                            alt="File"
                                            className="w-full h-full object-contain shadow-lg"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                        alertConfig.type === 'warning' ? 'border-yellow-500' :
                            alertConfig.type === 'info' ? 'border-blue-500' :
                                'border-green-500'
                        }`}>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                        alertConfig.type === 'info' ? 'bg-blue-100' :
                                            'bg-green-100'
                                    }`}>
                                    <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                        alertConfig.type === 'warning' ? 'text-yellow-600' :
                                            alertConfig.type === 'info' ? 'text-blue-600' :
                                                'text-green-600'
                                        }`}>
                                        {alertConfig.type === 'error' ? '✕' :
                                            alertConfig.type === 'warning' ? '⚠' :
                                                alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                    </span>
                                </div>
                            </div>
                            <div className="ml-3 flex-1">
                                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                            </div>
                            <button
                                onClick={() => setShowAlertModal(false)}
                                className="ml-4 text-gray-400 hover:text-gray-600"
                            >
                                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>

                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>

                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>

                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language]?.Cancel}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language]?.confirm}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}